
import { fetchMarque } from '@/assets/scripts/api'
import {
  bestPicFormat,
  createNavigationPopinItem,
} from '@/assets/scripts/utils'
import DetailToPopin from '@/mixins/DetailToPopin'
import PageData from '@/mixins/PageData'

export default {
  name: 'MarquePage',
  popinContentComponent: 'DetailPortrait',
  mixins: [PageData, DetailToPopin],

  async asyncData({ from, route }) {
    let shouldScrollToFounders = false
    if (from && from.params.popin && (!route.params || !route.params.popin)) {
      shouldScrollToFounders = true
    }
    return { apiData: await fetchMarque(), shouldScrollToFounders }
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },

  mounted() {
    setTimeout(() => {
      if (this.shouldScrollToFounders) {
        this.$refs.founders.scrollIntoView()
      }
    }, 1)
  },

  methods: {
    getPopinData() {
      const list = this.apiData ? this.apiData.founders : []
      return list.find((item) => item.slug === this.$route.params.popin)
    },

    getPopinNavItems() {
      let poster, url, media
      const list = this.apiData ? this.apiData.founders : []
      const popinNavItems = list
        .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
        .map((item) => {
          poster = bestPicFormat(item.video.poster, [
            'medium',
            'large',
            'origin',
          ])
          media = { desktop: item.video.desktop, mobile: item.video.mobile, youtubeID: item.video.youtubeID }
          url = '/marque/' + item.slug
          return createNavigationPopinItem(
            'MediaThumb',
            { props: { poster, media } },
            url
          )
        })
      return popinNavItems
    },
  },
}
